import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DisplayScorePlacements from './constants/DisplayScorePlacements';
import style from './style/displayscore.scss';

/**
 * Show extra score above the scorebar, optionally at the given position
 *
 * @example
 * <DisplayScore
 *     score={ 4.3 } // the score to display
 *     offset={ 4 } // optional offset. if not provided, score is displayed centered
 *     placement={ DisplayScorePlacement } // to differentiate in styling depending on where displayScore is used
 * />
 */
export default class DisplayScore extends Component {
    constructor(props) {
        super(props);

        this.getClassNameForDisplayScoreOffset = this.getClassNameForDisplayScoreOffset.bind(this);
    }

    getClassNameForDisplayScoreOffset() {
        const { placement, offset, classes } = this.props;

        // no offset provided, score will appear centered
        if (!offset) {
            return style.centered;
        }

        // if a placement type was provided, use its linked classNames, with fallback to default styling
        const offsetStyling = style[`${placement}__offset_${offset}`] || style[`offset_${offset}`]

        // return generic component styling amended by passed-on styling, amended by styling based on offset
        return `${style.displayScore} ${classes.root} ${offsetStyling}`
    }

    render() {
        const { score } = this.props;

        if (!score) {
            return null;
        }

        return (
            <div className={ this.getClassNameForDisplayScoreOffset() }>{ score }</div>
        );
    }
}

DisplayScore.propTypes = {
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placement: PropTypes.oneOf([DisplayScorePlacements.FIVE_POINT_BAR_GRAPH, '']),
    classes: PropTypes.shape({
        root: PropTypes.string
    })
};

DisplayScore.defaultProps = {
    placement: '',
    offset: null,
    classes: PropTypes.shape({
        root: ''
    })
};
